export const featurePaths = {
    jobServiceList: "/JobService",
    printLabelsPage: "/AddLabels/PrintLabelsPage",
    sustainabilityReport: "JobService/SustainabilityReport",
} as const;

export const apiPaths = {
    getAllJobServices: "/api/JobService/GetAllJobServices",
    getJobServiceById: "/api/JobService/GetJobServiceById",
    createJobService: "/api/JobService/CreateJobService",
    updateJobService: "/api/JobService/UpdateJobService",
    deleteJobService: "/api/JobService/DeleteJobService",
    getAllServiceStatus: "/api/CommonLookup/getallservicestatus",
} as const;